/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-12 10:03:10
 *
 *******************************************************/
import React from 'react';
import whyIconBlazing from 'src/assets/images/landing-page/turbo/why.blazing.svg';
import whyIconEnhanced from 'src/assets/images/landing-page/turbo/why.enhanced.svg';
import whyIconBrand from 'src/assets/images/landing-page/turbo/why.brand.svg';
import whyIconDesign from 'src/assets/images/landing-page/turbo/why.design.svg';
import whyIconB2b from 'src/assets/images/landing-page/turbo/why.b2b.png';
import whyIconShallow from 'src/assets/images/landing-page/turbo/why.shallow.png';
import step1Icon from 'src/assets/images/landing-page/turbo/step1.png';
import step2Icon from 'src/assets/images/landing-page/turbo/step2.png';
import step3Icon from 'src/assets/images/landing-page/turbo/step3.png';
import stepContactIcon from 'src/assets/images/landing-page/turbo/step.contact.svg';
import stepIntegrationIcon from 'src/assets/images/landing-page/turbo/step.integration.svg';
import { URL } from 'src/constants/links';

export const TURBO_LANDING_PAGE_DATA = i18n => {
  return {
    Features: [
      {
        title: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Blazing_Title',
        description: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Blazing_Description',
        icon: whyIconBlazing
      },
      {
        title: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Enhanced_Title',
        description: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Enhanced_Description',
        icon: whyIconEnhanced,
        link: URL['EnhancedVisualEditor']
      },
      {
        title: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Brand_Title',
        description: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Brand_Description',
        icon: whyIconBrand,
        link: URL['ShopifyIntegrationSettingsCodeEditor']
      },
      {
        title: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Design_Title',
        description: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Design_Description',
        icon: whyIconDesign,
        link: URL['PreDesignTemplate']
      },
      {
        title: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_B2B_Title',
        description: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_B2B_Description',
        icon: whyIconB2b,
        link: URL['B2BIntegration']
      },
      {
        title: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Shallow_Title',
        description: 'AdminHTML.LandingPage.Turbo.Turbo_Why_Item_Shallow_Description',
        icon: whyIconShallow,
        link: URL['SetupWidgetForTheme']
      }
    ],
    Steps: [
      {
        title: 'AdminHTML.LandingPage.Turbo.Turbo_Steps_Item1_Title',
        description: i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Steps_Item1_Description', {
          goto: (
            <b
              style={{
                display: 'inline-flex',
                flexWrap: 'wrap',
                alignItems: 'center'
              }}>
              <img style={{ marginRight: '4px' }} src={stepContactIcon} width={16} alt="" />
              <span>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Steps_Goto_Account')}</span>
              <span>&nbsp;{`>`}&nbsp;</span>
              <span>
                {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Steps_Goto_Preferences')}
              </span>
            </b>
          )
        }),
        icon: step1Icon
      },
      {
        title: 'AdminHTML.LandingPage.Turbo.Turbo_Steps_Item2_Title',
        description: i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Steps_Item2_Description', {
          goto: (
            <b
              style={{
                display: 'inline-flex',
                flexWrap: 'wrap',
                alignItems: 'center'
              }}>
              <img style={{ marginRight: '4px' }} src={stepIntegrationIcon} width={16} alt="" />
              <span>
                {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Steps_Goto_Integration')}
              </span>
              <span>&nbsp;{`>`}&nbsp;</span>
              <span>
                {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Steps_Goto_ShopifyIntegration')}
              </span>
            </b>
          )
        }),
        icon: step2Icon
      },
      {
        title: 'AdminHTML.LandingPage.Turbo.Turbo_Steps_Item3_Title',
        description: i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Steps_Item3_Description'),
        icon: step3Icon
      }
    ],
    Faqs: [
      {
        question: i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_1_Question'),
        answer: (
          <div>
            <p>
              {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_1_Answer_P1', {
                s1: (
                  <b>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_1_Answer_P1_Sub_1')}</b>
                )
              })}
            </p>
            <p>
              {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_1_Answer_P2', {
                s1: (
                  <b>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_1_Answer_P2_Sub_1')}</b>
                ),
                s2: (
                  <a rel="noopener noreferrer" target="_blank" href={URL['HowToUpgradeTurbo']}>
                    <span>
                      {i18n.translate(
                        'AdminHTML.LandingPage.Turbo.Turbo_Faq_1_Answer_P2_Sub_2_LinkDetail'
                      )}
                    </span>
                  </a>
                )
              })}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_2_Question'),
        answer: (
          <div>
            <p>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_2_Answer_P1')}</p>
            <p>
              {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_2_Answer_P2', {
                s1: (
                  <b>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_2_Answer_P2_Sub_1')}</b>
                )
              })}
            </p>
            <p>
              {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_2_Answer_P3', {
                s1: (
                  <b>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_2_Answer_P3_Sub_1')}</b>
                ),
                s2: (
                  <a rel="noopener noreferrer" target="_blank" href={URL['ManageTemplateGuide']}>
                    <span>
                      {i18n.translate(
                        'AdminHTML.LandingPage.Turbo.Turbo_Faq_2_Answer_P3_Sub_2_LinkWidgetTenplate'
                      )}
                    </span>
                  </a>
                ),
                s3: (
                  <a rel="noopener noreferrer" target="_blank" href={URL['EnhancedVisualEditor']}>
                    <span>
                      {i18n.translate(
                        'AdminHTML.LandingPage.Turbo.Turbo_Faq_2_Answer_P3_Sub_3_LinkPrebuild'
                      )}
                    </span>
                  </a>
                )
              })}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_3_Question'),
        answer: (
          <div>
            <p>
              {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_3_Answer_P1', {
                s1: (
                  <b>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_3_Answer_P1_Sub_1')}</b>
                )
              })}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_4_Question'),
        answer: (
          <div>
            <p>
              {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_4_Answer_P1', {
                s1: (
                  <b>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_4_Answer_P1_Sub_1')}</b>
                ),
                s2: (
                  <a
                    href={`mailto:${i18n.translate(
                      'AdminHTML.LandingPage.Turbo.Turbo_Faq_4_Answer_P1_Sub_2'
                    )}`}>
                    <b>
                      {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_4_Answer_P1_Sub_2')}
                    </b>
                  </a>
                )
              })}
            </p>
          </div>
        )
      },
      {
        question: i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_5_Question'),
        answer: (
          <div>
            <p>
              {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_5_Answer_P1', {
                s1: (
                  <b>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_5_Answer_P1_Sub_1')}</b>
                )
              })}
            </p>
            <p>
              {i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_5_Answer_P2', {
                s1: (
                  <b>{i18n.translate('AdminHTML.LandingPage.Turbo.Turbo_Faq_5_Answer_P2_Sub_1')}</b>
                )
              })}
            </p>
          </div>
        )
      }
    ]
  };
};

export const TURBO_LANDING_PAGE_SECTION_TOOLTIP = [
  { id: 'intro', title: 'AdminHTML.LandingPage.Turbo.Tooltip.SectionIntro' },
  { id: 'what-is', title: 'AdminHTML.LandingPage.Turbo.Tooltip.SectionWhatIs' },
  { id: 'how-fast', title: 'AdminHTML.LandingPage.Turbo.Tooltip.SectionHowFast' },
  { id: 'why', title: 'AdminHTML.LandingPage.Turbo.Tooltip.SectionWhy' },
  { id: 'steps', title: 'AdminHTML.LandingPage.Turbo.Tooltip.SectionSteps' },
  { id: 'faq', title: 'AdminHTML.LandingPage.Turbo.Tooltip.SectionFaq' },
  { id: 'contact', title: 'AdminHTML.LandingPage.Turbo.Tooltip.SectionContact' },
  { id: 'banner', title: 'AdminHTML.LandingPage.Turbo.Tooltip.SectionBanner' }
];